import React from 'react';
import { Container, Card, CardBody, CardTitle, CardText } from 'react-bootstrap';

function About() {
  return (
    <Container className="mt-3 mb-5">
      <Card className="mb-3">
        <CardBody>
          <CardTitle className="fw-bold">About</CardTitle>
          <CardText>
            Dolt Labs Daily Tools is a comprehensive suite of tools designed to help you manage your daily tasks efficiently.
          </CardText>
        </CardBody>
      </Card>

      <div className="mt-4">
        <h2 className="fs-5 fw-bold">Our Vision</h2>
        <p className="fs-6">
          At Dolt Labs, we envision a world where technology empowers individuals and organizations to achieve their highest potential. Our tools are designed to be intuitive, powerful, and adaptable to meet the diverse needs of our users.
        </p>
      </div>
      <div className="mt-4">
        <h2 className="fs-5 fw-bold">Our Commitment</h2>
        <p className="fs-6">
          We are dedicated to providing exceptional customer service and support. Our team is constantly working to enhance our tools and introduce new features that address the evolving needs of our users.
        </p>
      </div>
      <div className="mt-4">
        <h2 className="fs-5 fw-bold">Join Us</h2>
        <p className="fs-6">
          Join the Dolt Labs community and be part of a growing network of professionals who are leveraging our tools to achieve their goals. Stay tuned for updates and new releases as we continue to innovate and improve.
        </p>
      </div>
    </Container>
  );
}

export default About;
